import { intelligentPhotoCaptureConstants } from '../constants';
/**
 * PhotoCapture Image Batch Processing Actions
 * These actions are triggered only for specific workflows (e.g., Summary workflow)
 */
export const INTELLIGENT_PHOTO_CAPTURE_IMAGE_BATCH_PROCESSING_REQUEST = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_IMAGE_BATCH_PROCESSING_REQUEST`;
export const INTELLIGENT_PHOTO_CAPTURE_SET_SCREEN_NAME = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_SET_SCREEN_NAME`;
export const INTELLIGENT_PHOTO_CAPTURE_DOCUMENT_BATCH_PROCESSING_REQUEST = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_DOCUMENT_BATCH_PROCESSING_REQUEST`;
/**
 * Action creator for photo capture image batch processing
 * @param payload - File upload complete payload
 */
export const photoCaptureIntelligentImageBatchProcessingRequestAction = (payload) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_IMAGE_BATCH_PROCESSING_REQUEST,
    payload
});
/**
 * Action creator for setting the screen name in photo capture state
 * @param screenName - The screen name to set for context tracking
 * @returns Action with screen name payload
 */
export const photoCaptureIntelligentSetScreenNameAction = (screenName) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_SET_SCREEN_NAME,
    payload: { screenName }
});
export const photoCaptureIntelligentDocumentBatchProcessingRequestAction = (payload) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_DOCUMENT_BATCH_PROCESSING_REQUEST,
    payload: Object.assign({}, payload)
});
//# sourceMappingURL=photoCaptureIntelligentBatchProcessingAction.js.map